<template>
	<el-container :style="styleObject">
		<el-header class="header">
			<header-layout :org="orgInfo"></header-layout>
		</el-header>
		<el-container>
			<el-aside width="200px">
				<menu-layout :org="orgInfo"></menu-layout>
			</el-aside>
			<el-main>
				<router-view></router-view>
			</el-main>
		</el-container>
	</el-container>
</template>
<script>
	import MenuLayout from '../layouts/Menu.vue';
	import HeaderLayout from '../layouts/Header.vue';

	import config from "../../config/global.js";
	import axios from "axios"
	var getOrgInfoUrl = config.host+"/backend/org/get.json";

	export  default {
		data:function(){
			return {
				styleObject:{
					"height":window.innerHeight+"px"
				},
				loading:false,
				orgInfo:{}
			}
		},
		components: {
			MenuLayout,
			HeaderLayout,
		},
		mounted:function(){
			this.getOrgInfo();
		},
		methods: {
			getOrgInfo:function () {
				this.loading=true;
				axios({
					method: 'post',
					url:getOrgInfoUrl
				}).then((response)=>{
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					if(response.data.result == 1){
						this.orgInfo = response.data;
					}else{
						this.$alert(response.data.emsg, '请求失败', {
							confirmButtonText: '确定'
						});
					}
					this.loading = false;
				}).catch((error)=>{
					this.loading = false;
					this.$alert(error.response.statusText, '请求失败', {
						confirmButtonText: '确定'
					});
				})
			}
		},
		watch: {

		}

	}

</script>
<style scoped>
	.header{
		background-color: #373737;
		box-shadow: 0 1px 3px rgba(0,0,0,0.3);
	}

</style>





// WEBPACK FOOTER //
// src/pages/Index.vue